export default __webpack_public_path__ + "node_modules/owl.carousel/dist/assets/owl.video.play.png";